import React from "react";
import "../styles/Header.css";

const Header = ({ stats }) => {
  return (
    <header className="header">
      <div className="header-content">
        <a
          href="https://www.earthlyadvocate.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="logo-link"
        >
          <img src="/logo.png" alt="Logo" className="header-logo-left" />
        </a>

        <div className="header-left">
          <h1>Michigan Toxic Chemical Releases in 2024</h1>
          <p className="subtitle">Interactive Facility Mapping & Analysis</p>
        </div>

        <div className="header-stats">
          <div className="stat-card">
            <span className="stat-number">{stats.total.toLocaleString()}</span>
            <span className="stat-label">Total Reports</span>
          </div>
          <div className="stat-card carcinogen">
            <span className="stat-number">
              {stats.carcinogen.toLocaleString()}
            </span>
            <span className="stat-label">Carcinogen </span>
          </div>
          <div className="stat-card non-carcinogen">
            <span className="stat-number">
              {stats.nonCarcinogen.toLocaleString()}
            </span>
            <span className="stat-label">Non-Carcinogen</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
